import { createSelector } from '@ngrx/store';
import * as fromModels from '../models';
import * as fromReducers from '../reducers';

export const getLogged = createSelector(
  fromReducers.getUiState,
  (uiState: fromModels.IUiModel) => uiState.logged
);

export const getCurrentUser = createSelector(
  fromReducers.getUiState,
  (uiState: fromModels.IUiModel) => uiState.currentUser
);

export const getTouchpoint = createSelector(
  fromReducers.getUiState,
  (uiState: fromModels.IUiModel) => uiState.touchpoint
);

export const getGoal = createSelector(
  fromReducers.getUiState,
  (uiState: fromModels.IUiModel) => uiState.goal
);

export const getTrigger = createSelector(
  fromReducers.getUiState,
  (uiState: fromModels.IUiModel) => uiState.trigger
);

export const getCategory = createSelector(
  fromReducers.getUiState,
  (uiState: fromModels.IUiModel) => uiState.category
);

export const getLanguages = createSelector(
  fromReducers.getUiState,
  (uiState: fromModels.IUiModel) => uiState.languages
);

export const getCountries = createSelector(
  fromReducers.getUiState,
  (uiState: fromModels.IUiModel) => uiState.countries
);



// WEBPACK FOOTER //
// ./src/app/shared/store/selectors/ui.selectors.ts